import React from 'react';
import { Text } from 'components/atoms';

const SubWebCoursesEditor = () => (
  <Text modifiers="content">
    Por ser totalmente dinâmico este módulo não precisa de ser editado.
    Se quiser adicionar uma secção com ligações configuradas por si deve usar o módulo Links.
  </Text>
);

export default SubWebCoursesEditor;
